import fertigationDataConfig from '@/api/config/fertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useDetailFertigation(interfaceId: number, id: number) {
  return useQuery({
    queryKey: [queryKeys.fertigationId, id, interfaceId],
    queryFn: async () => {
      const { data } = await fertigationDataConfig.getById(interfaceId, id)
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useDetailFertigation
